export const billingAccessCopy = {
  "en": {
    "label": "Billing access",
    "message": "Ask the shop owner to grant Billing access to manage the wallet, subscription, and credits.",
    "fullAccess": "All staff permissions, including wallet, subscription, and credit management."
  },
  "ar": {
    "label": "صلاحية الفوترة",
    "message": "اطلب من مالك المتجر منحك صلاحية الفوترة لإدارة المحفظة والاشتراك والرصيد.",
    "fullAccess": "جميع صلاحيات الموظفين، بما فيها إدارة المحفظة والاشتراك والرصيد."
  },
  "fr": {
    "label": "Accès à la facturation",
    "message": "Demandez au propriétaire l’accès à la facturation pour gérer le portefeuille, l’abonnement et les crédits.",
    "fullAccess": "Toutes les autorisations du personnel, y compris la gestion du portefeuille, de l’abonnement et des crédits."
  },
  "ha": {
    "label": "Izinin biyan kuɗi",
    "message": "Nemi mai shago ya ba ka izinin biyan kuɗi don sarrafa wallet, tsarin biyan kuɗi, da kiredit.",
    "fullAccess": "Dukkan izinin ma’aikata, har da sarrafa wallet, tsarin biyan kuɗi, da kiredit."
  },
  "ig": {
    "label": "Ikike ịkwụ ụgwọ",
    "message": "Rịọ onye nwe ụlọ ahịa ka o nye gị ikike ịkwụ ụgwọ iji jikwaa wallet, ndenye aha na kredit.",
    "fullAccess": "Ikike ndị ọrụ niile, gụnyere njikwa wallet, ndenye aha na kredit."
  },
  "pt": {
    "label": "Acesso à faturação",
    "message": "Peça ao proprietário acesso à faturação para gerir a carteira, a subscrição e os créditos.",
    "fullAccess": "Todas as permissões de pessoal, incluindo gestão da carteira, subscrição e créditos."
  },
  "sw": {
    "label": "Ruhusa ya malipo",
    "message": "Mwombe mmiliki wa duka ruhusa ya malipo ili kusimamia wallet, usajili na salio.",
    "fullAccess": "Ruhusa zote za wafanyakazi, pamoja na usimamizi wa wallet, usajili na salio."
  },
  "yo": {
    "label": "Àṣẹ ìdíyelé",
    "message": "Beere lọ́wọ́ olówó ṣọ́ọ̀bù fún àṣẹ ìdíyelé láti ṣàkóso àpò owó, ìforúkọsílẹ̀ àti kírẹ́díìtì.",
    "fullAccess": "Gbogbo àṣẹ òṣìṣẹ́, pẹ̀lú ìṣàkóso àpò owó, ìforúkọsílẹ̀ àti kírẹ́díìtì."
  },
  "zu": {
    "label": "Imvume yokukhokha",
    "message": "Cela umnikazi wesitolo akunike imvume yokuphatha isikhwama, ukubhalisa namakhredithi.",
    "fullAccess": "Zonke izimvume zabasebenzi, okuhlanganisa ukuphatha isikhwama, ukubhalisa namakhredithi."
  }
};
